<template>
    <div class="align-items-center header-icons">
        <div v-for="icon in headerIcons" :key="icon.id" class="position-relative">
            <EDropdown
                v-if="icon.visible()"
                :id="icon.id"
                :key="icon.id"
                class="e3-dropdown-circle e3-arrow-drop e3-icons-drop e3-header-icons"
                btn-class="text-decoration-none"
                :x-offset="18"
                :y-offset="10"
                placement="bottom-end"
                variant="circle"
                lazy
                @toggle="() => dropToggled(icon.id)">
                <template #icon="{open}">
                    <component :is="icon.component" size="20" :class="open ? 'text-primary' : 'text-white'"/>
                </template>
                <template #content="{close}">
                    <component :is="icon.id" :id="icon.id" @close="close"/>
                </template>
            </EDropdown>
            <label
                v-if="icon.visible() && icon.newCount() !== 0"
                :for="icon.id"
                class="d-flex align-items-center justify-content-center e3-header-label bg-success rounded-circle text-white position-absolute font-weight-bold"
                :class="{'e3-over-99': icon.newCount() > 99}">
                <span>
                    {{ countNew(icon.newCount()) }}
                </span>
            </label>
        </div>
    </div>
</template>

<script>
import { GALogEvent } from '@/utils/firebase';
import { mapGetters } from 'vuex';
import Messages from './Messages.vue';
import Announcements from './Announcements.vue';
import Calendar from './Calendar.vue';
import Cloud from './Cloud.vue';
import Notifications from './Notifications.vue';
import Cart from './Cart.vue';
import CartVariantIcon from '@/common/components/svg-icons/CartVariantIcon.vue';
import BellIcon from '@/common/components/svg-icons/BellIcon.vue';
import BullhornIcon from '@/common/components/svg-icons/BullhornIcon.vue';
import MessageTextIcon from '@/common/components/svg-icons/MessageTextIcon.vue';
import CalendarBlankIcon from '@/common/components/svg-icons/CalendarBlankIcon.vue';
import CloudIcon from '@/common/components/svg-icons/CloudIcon.vue';
import EDropdown from '@components/Dropdown';

export default {
    data() {
        return {
            headerIcons: [
                {
                    id: 'Cart',
                    component: CartVariantIcon,
                    newCount: () => this.userRecentCart.count,
                    visible: () => this.userRecentCart.count
                },
                {
                    id: 'Notifications',
                    component: BellIcon,
                    newCount: () => this.unreadNotificationsCount,
                    visible: () => this.currentEmployee || this.currentGuardian //TODO official and guardian support
                },
                {
                    id: 'Announcements',
                    component: BullhornIcon,
                    newCount: () => this.unreadAnnouncements,
                    visible: () => this.canAccessAnnouncement
                },
                {
                    id: 'Messages',
                    component: MessageTextIcon,
                    newCount: () => this.unreadMessages,
                    visible: () => this.activeKindergartenId || this.activeOrganizationId
                },
                {
                    id: 'Calendar',
                    component: CalendarBlankIcon,
                    newCount: () => this.newEventsCount,
                    visible: () => this.canAccessEventsIndex || this.canAccessOrgEventsIndex
                },
                {
                    id: 'Cloud',
                    component: CloudIcon,
                    newCount: () => this.unseenDocumentCount,
                    visible: () => this.canAccessDocumentsIndex
                }
            ]
        };
    },
    computed: {
        ...mapGetters([
            'unreadMessages',
            'unreadAnnouncements',
            'unseenDocumentCount',
            'activeKindergartenId',
            'newEventsCount',
            'canAccessEventsIndex',
            'canAccessDocumentsIndex',
            'activeOrganizationId',
            'canAccessAnnouncement',
            'canAccessOrgEventsIndex',
            'unreadNotificationsCount',
            'currentEmployee',
            'currentGuardian',
            'userRecentCart'
        ])
    },
    methods: {
        countNew(count) {
            if (count <= 99 || typeof count === 'string') {
                return count;
            } else {
                return '99+';
            }
        },
        dropToggled(id) {
            GALogEvent('header_notif_open', {
                button_name: id
            });
        }
    },
    components: {
        Cart,
        Notifications,
        Announcements,
        Messages,
        Calendar,
        Cloud,
        EDropdown
    }
};
</script>

<style scoped>
.e3-header-label {
    font-size: 80%;
    top: -8px;
    right: -4px;
    height: 1.3rem;
    width: 1.3rem;
    z-index: 10;
}
.e3-over-99 {
    height: 1.6rem !important;
    width: 1.6rem !important;
    top: -12px !important;
    right: -8px !important;
}
</style>
